import { stateCurrentAppeal } from 'feature/appeals/redux/appealFormCreateSelector'
import { useLazyOfferRecalculationQuery } from 'feature/appeals/redux/appeals.api'
import { AppealLoadingList, TAppealOffer } from 'feature/appeals/type'
import { useSetNotice } from 'hooks/useSetNotice'
import { useActions, useAppSelector } from 'store/hooks'
import { Severity } from 'widget/Notifications'

import { OfferPaymentApproved } from './OfferPaymentApproved/OfferPaymentApproved'
import { OfferPaymentDefault } from './OfferPaymentDefault/OfferPaymentDefault'

type TAppealOfferProps = {
  offerItem: TAppealOffer
  hasApprovedOrder: boolean
  hasPaidOrder: boolean
}

// информацией об оплате КП

export const AppealOffer = ({
  offerItem,
  hasPaidOrder,
  hasApprovedOrder,
}: TAppealOfferProps) => {
  const { setIsPullingStopped, setLoading } = useActions()
  const [recalculateOffer] = useLazyOfferRecalculationQuery()
  const { editAppealLoading } = useAppSelector(stateCurrentAppeal)

  const setNotice = useSetNotice()

  const recalculateHandler = (id: number) => {
    setIsPullingStopped(true)
    setLoading({
      type: AppealLoadingList.appealRecalcBlock,
      value: true,
    })
    recalculateOffer(id)
      .then(res => {
        //@ts-ignore
        if (res.data.success) {
          setNotice('Ваша заявка на перерасчет отправлена', Severity.success)
          return
        }

        setNotice('Ошибка. Повторите позднее', Severity.error)
      })
      .catch(() => {
        setNotice('Ошибка. Повторите позднее', Severity.error)
      })
      .finally(() => {
        setIsPullingStopped(false)
      })
  }

  if (!offerItem.offer) return <></>
  return (
    <>
      {offerItem.status === 'APPROVED' && (
        <OfferPaymentApproved
          offer={offerItem.offer}
          hasPaidOrder={hasPaidOrder}
          recalcInProgress={offerItem.recalcInProgress}
          recalculateHandler={recalculateHandler}
          isOfferRecalcLoading={editAppealLoading.appealRecalcBlock}
        />
      )}

      {(offerItem.status === 'SENT' || offerItem.status === 'DECLAINED') && (
        <OfferPaymentDefault
          status={offerItem.status}
          offer={offerItem.offer}
          hasApprovedOrder={hasApprovedOrder}
          hasPaidOrder={hasPaidOrder}
          recalcInProgress={offerItem.recalcInProgress}
          recalculateHandler={recalculateHandler}
          isOfferRecalcLoading={editAppealLoading.appealRecalcBlock}
        />
      )}
    </>
  )
}
